import { SnackbarProvider } from 'notistack';
import * as React from 'react';

export interface ISnackBarProviderConfigProps {
    children:React.ReactElement | React.ReactNode
}

export default function SnackBarProviderConfig ({ children }: ISnackBarProviderConfigProps) {
  return (
      <SnackbarProvider
        maxSnack={2}
        preventDuplicate
        autoHideDuration={4000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
          {children}
      </SnackbarProvider>
  );
}
